<script>
import ViewAlerts from "@/modules/common/views/ViewAlerts";

export default {
    name: "Alerts",
    functional: true,
    render(createElement) {
        return createElement(ViewAlerts);
    }
};
</script>
